export default __webpack_public_path__ + "athlete.png";